import React from 'react';
import classNames from 'classnames';

import Grid from '@mui/material/Grid';
import Input from '@mui/material/TextField';

import TranslationIds from '../../../commons/translationIds';

function renderCustomParentEmail (p) {
    const {
        fieldErrors,
        classes,
        translate,
        touched,
        customValues,
        updateCustomValues,
        parentConsentFieldName,
        parentConsentFieldRequired,
    } = p;

    function getLabel () {
        if (parentConsentFieldRequired) {
            return `${translate(TranslationIds.REGISTRATION_LABEL_PARENT_EMAIL)}*`;
        }
        return translate(TranslationIds.REGISTRATION_LABEL_PARENT_EMAIL);
    }

    function getParentalConsent () {
        if (!customValues[parentConsentFieldName]) {
            return '';
        }
        return customValues[parentConsentFieldName];
    }

    function getHelperText () {
        if (touched.parentEmail && fieldErrors.parentEmail) {
            return translate(TranslationIds.REGISTRATION_VALID_PARENT_EMAIL);
        }
        return '';
    }
 
    function inputClass () {
        if (fieldErrors.parentEmail) {
            return classes.inputBaseError;
        }
        return classes.inputBase;
    }

    function renderParentEmailField () {
        if (getParentalConsent().toLowerCase() !== 'no') {
            return (<React.Fragment></React.Fragment>);
        }

        return (
            <Grid className={classNames(['ecal-reg-field-custom-field-parentemail', classes.fieldRoot])}>
                <span className={classNames(['ecal-input-label', classes.fieldLabel])}>
                    {getLabel()}
                </span>
                <Input
                    id="parentEmail"
                    name="parentEmail"
                    className={inputClass()}

                    InputProps={{
                        classes: {
                            underline: classes.InputUnderline,
                            input: classes.textInput,
                        },

                    }}

                    onBlur={(e) => {
                        updateCustomValues({
                            parentEmail: e.target.value?.trim(),
                        });
                    }}

                    onChange={e => {
                        // debounce the changes...
                        updateCustomValues({
                            parentEmail: e.target.value?.trim(),
                        },
                        {
                            selector: '#parentEmail',
                            field: 'parentEmail',
                        });
                    }}

                    margin="normal"
                    
                    type="text"
                    fullWidth
                    error={ fieldErrors.parentEmail}
                    helperText={getHelperText()}
                />
            </Grid>
        );
    }
    return (
        <React.Fragment>
            { renderParentEmailField() }
        </React.Fragment>
        
    );
}

export default renderCustomParentEmail;